import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

interface Props {
  children: ReactNode;
  icon?: Icon;
  margin?: boolean;
}

const PillItem = ({ children, icon, margin = true }: Props) => {
  const className = classnames({
    'items-center': true,
    'bg-pill-background-color': true,
    'rounded-2xl': true,
    'text-pill-color': true,
    flex: true,
    'flex-row': true,
    'flex-nowrap': true,
    'text-xs': true,
    'h-7': true,
    'justify-center': true,
    'leading-7': true,
    'py-1': true,
    'px-2.5': true,
    'pointer-events-none': true,
    'w-fit': true,
    'mt-0': margin,
    'mr-2': margin,
    'mb-2': margin,
    'ml-0': margin,
    'only:!mr-0': true,
    'last:!mr-0': true,
  });

  return (
    <div className={className}>
      <div className="flex flex-row items-center justify-center mr-1.5">
        <IconView icon={icon} size={'lg'} />
      </div>
      <div className="flex items-center justify-center">{children}</div>
    </div>
  );
};

export default PillItem;
